import { render, staticRenderFns } from "./NumberCounter.vue?vue&type=template&id=59b33072&scoped=true"
import script from "./NumberCounter.vue?vue&type=script&lang=js"
export * from "./NumberCounter.vue?vue&type=script&lang=js"
import style0 from "./NumberCounter.vue?vue&type=style&index=0&id=59b33072&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b33072",
  null
  
)

export default component.exports